var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-design robot2s" }, [
    _c("div", { staticClass: "banner", attrs: { id: "design-b1" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB1Visible } }, [
          _vm._v("极光流线型设计")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("处处彰显科技感")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b2" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB2Visible } }, [
          _vm._v("V 字蓝光")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("闪耀光芒")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b3" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB3Visible } }, [
          _vm._v("36种拟人化表情")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("贴心动人")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b4" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB4Visible } }, [
          _vm._v("绝美音质")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1 mt10", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("听音乐如临现场")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-636db903", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-636db903","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/2s/design.vue
// module id = Fq+V
// module chunks = 0